import { render, staticRenderFns } from "./printregistrationfee.vue?vue&type=template&id=212289aa"
import script from "./printregistrationfee.vue?vue&type=script&lang=js"
export * from "./printregistrationfee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports